var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search__flyout",
      class: _vm.hasResultClass,
      attrs: { id: "search__flyout" },
    },
    [
      _c("div", { staticClass: "search__wrap" }, [
        _c("div", { staticClass: "search__field" }, [
          _c(
            "form",
            {
              staticClass: "search__form",
              attrs: { action: _vm.urls.submit },
              on: { submit: _vm.handleSubmit },
            },
            [
              _c("div", { staticClass: "search__formfield" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchTerm,
                      expression: "searchTerm",
                    },
                  ],
                  ref: "searchInput",
                  staticClass: "search__input",
                  attrs: {
                    "data-brand-group-name": _vm.messageKeys.searchSuggestBrand,
                    "data-category-group-name":
                      _vm.messageKeys.searchSuggestCategory,
                    "data-product-group-name":
                      _vm.messageKeys.searchSuggestProduct,
                    "data-search-suggest-more-text":
                      _vm.messageKeys.searchSuggestMoreText,
                    "data-suggestions-group-name":
                      _vm.messageKeys.searchSuggestSuggestions,
                    placeholder: _vm.messageKeys.searchboxPlaceholder,
                    autocomplete: "off",
                    maxlength: "128",
                    name: "q",
                    type: "search",
                  },
                  domProps: { value: _vm.searchTerm },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.searchTerm = $event.target.value
                      },
                      _vm.handleInput,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "search__reset",
                    attrs: { type: "reset" },
                    on: { click: _vm.resetInput },
                  },
                  [_c("CloseIcon")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "search__button", attrs: { type: "submit" } },
                  [_c("SearchIcon")],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "search__close",
              attrs: { type: "button" },
              on: { click: _vm.closeFlyout },
            },
            [_c("CloseIcon")],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.searchTerm.length >= 2
          ? _c("div", { staticClass: "search__results" }, [
              _c("div", { staticClass: "search__categories" }, [
                _c("div", { staticClass: "search__subheadline" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.messageKeys.searchSuggestCategory) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.categories.length
                  ? _c(
                      "ul",
                      { staticClass: "search__categories-list" },
                      _vm._l(_vm.categories, function (category, index) {
                        return _c("SearchCategoryItem", {
                          key: category.categoryId,
                          attrs: {
                            "highlighted-name": category.entryHighlightedTitle,
                            index: index,
                            name: category.entryName,
                            url: category.entryUrl,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search__products" }, [
                _c("div", { staticClass: "search__subheadline" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.messageKeys.searchSuggestProduct) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.products.length
                  ? _c(
                      "div",
                      { staticClass: "search__products-list" },
                      _vm._l(_vm.products, function (product, index) {
                        return _c("SearchProductItem", {
                          key: index,
                          attrs: {
                            "highlighted-name": product.entryHighlightedTitle,
                            "image-url": product.imageUrl,
                            index: index,
                            "min-price": product.minPrice,
                            name: product.entryName,
                            "old-price": product.oldPrice,
                            url: product.entryUrl,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.searchTerm.length >= 2
          ? _c("div", { staticClass: "search__more more-wrapper" }, [
              _c(
                "a",
                {
                  staticClass: "jh-btn-secondary search__more-button",
                  attrs: { href: _vm.moreLink },
                },
                [_vm._v(_vm._s(_vm.messageKeys.searchSuggestMoreText))]
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }